import React, {
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  useMemo,
} from "react";
import {
  allColumns,
  itemsInputField as inputFieldsInit,
  listYears,
} from "./ListTimekeeping.config";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { getPhongBanAPI } from "../../../../../redux/reducer/employee";
import { ColumnProps } from "../../../../../types/models";
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Popover,
  Row,
  Select,
  Space,
  Table,
  Typography,
} from "antd";
import { Collapse } from "antd";
import { Descriptions } from "antd";
import type { DatePickerProps, DescriptionsProps } from "antd";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  ListActionButton,
  Search,
} from "../../../../../components/common";
import axiosClient from "../../../../../api/axiosClient";
import Icons from "../../../../../assets/icons";
import {
  ExcelSVG,
  FrameDow,
  FrameUp,
  SaveWhiteIconSVG,
  UploadSVG,
} from "../../../../../assets";
import moment from "moment";
import { FIELD_TYPE, FORMAT_TIME } from "../../../../../types/enums";
import Notification from "../../../../../components/common/notification/notification";
import { employeeService } from "api";
import { searchChamCong } from "redux/reducer/employee";
import { UploadOutlined as upload } from "@ant-design/icons/lib/icons";
import dayjs from "dayjs";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import "./styles.scss";
import {
  generateFileName,
  saveTableOptions,
  getTableOptions,
  isApproveRecord,
} from "../../../../../helper/common";
import { setButtonsHeader } from "redux/reducer/common";
import columns from "../../../../Refractive/InforDetails/DryAutoRefraction/FillBtn/config";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { dataSample } from "pages/Glass/GlassKiosk/Detail/BillGlass/config";
import usePermission from "hooks/usePermission";
import { useWatch } from "antd/es/form/Form";
import { DataFormField } from "types/models/input-field-type";
import ExpandSearchHCNS from "components/common/ExpandSearch/ExpandSearchHCNS";
const ListTimekeeping = () => {
  const listCharacters = [
    { value: "1", label: "1" },
    { value: "0.5", label: "0.5" },
    { value: "NP", label: "NP" },
    { value: "1/2P", label: "1/2P" },
    { value: "0.5P", label: "0.5P" },
    { value: "0", label: "0" },
    { value: "NB", label: "NB" },
    { value: "1/2B", label: "1/2B" },
    { value: "0.5B", label: "0.5B" },
    { value: "B/P", label: "B/P" },
    { value: "NL", label: "NL" },
    { value: "ÔC", label: "ÔC" },
    { value: "1/2ÔC", label: "1/2ÔC" },
    { value: "KL", label: "KL" },
    { value: "TS", label: "TS" },
    { value: "Ô", label: "Ô" },
    { value: "CĐ", label: "CĐ" },
    { value: "0.5ÔC", label: "0.5ÔC" },
    { value: "MT", label: "MT" },
    { value: "0.5NL", label: "0.5NL" },
    { value: "0.5MT", label: "0.5MT" },
    { value: "CÔ", label: "CÔ" },
    { value: "0.5CÔ", label: "0.5CÔ" },
    { value: "1/2CÔ", label: "1/2CÔ" },
  ];
  const [showDescriptions, setShowDescriptions] = useState(false);
  const { isNhanVien, isQuanLy, isGiamDoc } = usePermission();
  const toggleDescriptions = () => {
    setShowDescriptions(!showDescriptions);
  };
  const today = new Date();
  const currentYear = today.getFullYear(); // Lấy năm hiện tại (ví dụ: 2023)
  const currentMonth = today.getMonth() + 1; // Lấy tháng hiện tại (0 - 11, cần cộng thêm 1 để có giá trị tháng thực tế)
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<any[]>([]);

  const [params, setParams] = useState<any>({
    page: 1,
    nam: currentYear,
    thang: currentMonth,
    limit: 10,
  });
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  // let savedTableOption = getTableOptions(
  //   "LISTTIMEKEEPING_TABLE",
  //   localStorage.getItem("username")
  // );
  // const defaultColumns = savedTableOption
  //   ? allColumns.map(cl => {
  //       if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
  //         let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
  //         return {
  //           ...cl,
  //           show: true,
  //           width: tmp?.width ?? null,
  //         };
  //       } else
  //         return {
  //           ...cl,
  //           show: false,
  //         };
  //     })
  //   : allColumns;
  const [columns, setColumns] = useState<any>(
    allColumns.filter((e) => e.show == true)
  );
  columns.map((e) => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [paramss, setParamss] = useState<any>({});
  const employees = useAppSelector((state) => state.employeesReducer);
  const modalRef = useRef<any>();
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const activeTab = useAppSelector((e) => e.common.activeTab);
  const onClickSearch = async () => {
    await form.validateFields();
    setCurrentPage(1);
    var searchFields = expandRef?.current?.getData();
    setParams({ ...params, ...searchFields, page: 1 });
    setParamss({ ...paramss, ...searchFields }); // Đặt trang về 1 khi thực hiện tìm kiếm
  };
  useEffect(() => {
    expandRef?.current.setFieldValue("nam", currentYear);
    expandRef?.current.setFieldValue("thang", currentMonth);
  }, []);
  const getList = async () => {
    setLoading(true);
    setSelectedRowKeys([]);
    await dispatch(searchChamCong(params));
    setLoading(false);
  };
  useEffect(() => {
    getList();
  }, [params, activeTab]);

  useEffect(() => {
    setData(
      employees.ChamCongList.map((rowData) => {
        return {
          ...rowData,
          key: rowData.id,
        };
      })
    );
  }, [employees.ChamCongList]);
  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    // const numberOfDaysInMonth = new Date(nam, thang, 0).getDate();
    // const dataIndex =  showColumns.filter(element => element.dataIndex === "nam")
    // for (let i = 0; i < dataIndex.children.length ; i++) {
    //
    // }
    setColumns(showColumns);
  };

  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  const onClickKiCong = async () => {
    try {
      let soNgayThangChamCong;

      if ([5, 7, 10, 12].includes(params.thang)) {
        soNgayThangChamCong = 2; //2 là 30 ngày
      } else if (params.thang === 3) {
        // Tháng 2 có 28 ngày, nhưng nếu là năm nhuận thì có 29 ngày
        if (isLeapYear(params.nam)) {
          soNgayThangChamCong = 1; // 1 là 29 ngày
        } else {
          soNgayThangChamCong = 0; //0 là 28 ngày
        }
      } else {
        soNgayThangChamCong = 3; // Mặc định là 31 nếu không khớp với các trường hợp cụ thể
      }

      const body = {
        thang: params.thang,
        soNgayThangChamCong: soNgayThangChamCong,
      };
      //console.log(body);
      const res = await employeeService.updateKiCong(body);
      getList();
      Notification("success", "Cập nhật kì công thành công");
    } catch (res) {
      Notification("error", "Cập nhật kì công thất bại");
    }
  };

  // Hàm kiểm tra năm nhuận
  function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({ ...params, ...searchFields });
    handleExportExcel(params);
  };

  const handleExportExcel = async (params) => {
    const url = "hanhchinhnhansu/cham-cong/export-excel";
    const baseName = "danh-sach-cham-cong-chi-tiet";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Lỗi khi tải xuống file excel");
    }
  };
  // const handleOnAdd = async () => {
  //   try {
  //     const response = await employeeService.phatSinhChamCong(params);

  //     if (response.data.code == 200) {
  //       Notification("success", "thêm bảng chấm công thành công");
  //       getList();
  //     } else {
  //       Notification("warning", response.data.message);
  //     }
  //   } catch (err) {
  //     Notification("error", "Lỗi khi thêm bảng chấm công");
  //   }
  // };
  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const excel = event.target.files[0];

      const formData = new FormData();
      formData.append("files", excel);
      try {
        const response = await employeeService.uploadChamCong(formData);
        if (response.status == 200) {
        }
        Notification("success", "Tải file excel lên thành công");
      } catch (err) {
        Notification("error", "Lỗi khi tải lên file excel");
      }
    }
  };
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const datas = data.map((rowData) => {
        let abc: any = {};
        let keyName = "";
        let value = "";
        for (const key in rowData) {
          if (key.startsWith("day")) {
            keyName = key;
            value =
              rowData[key] === "TRUE" || rowData[key] === "FALSE"
                ? "0"
                : rowData[key];
            abc[key] = value;
          }
        }
        return {
          ...rowData,
          ...abc,
          key: rowData.id,
        };
      });
      const res = await employeeService.updateChamCong(datas);

      getList();
      Notification("success", "Cập nhập thành công ");
    } catch (res) {
      Notification("error", "Cập nhập thất bại");
    }
    getList();
  };

  useEffect(() => {
    dispatch(
      getPhongBanAPI({
        page: 1,
        limit: 100,
      })
    );
  }, []);
  useEffect(() => {
    setOptionsPBFields(employees.phongBanList, "idPhongBan");
  }, [employees.phongBanList]);
  const setOptionsPBFields = (list, tenPhongBan) => {
    if (inputFieldsInit.find((field) => field.name === tenPhongBan)) {
      inputFieldsInit.find((field) => field.name === tenPhongBan).options =
        list?.map((item) => ({
          value: item.id,
          label: item.tenPhongBan,
        }));
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };
  const onKeyDownSearch = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  // Xác định độ dài của mảng columns
  const numberOfColumns = columns.length;

  // Thiết lập giá trị scroll dựa vào số lượng cột
  let scrollX;
  if (numberOfColumns <= 5) {
    scrollX = 3000;
  } else {
    scrollX = 4000;
  }
  const nam = params.nam;
  const thang = params.thang;
  const filteredColumns = allColumns.filter((e) => e.dataIndex === "nam");
  filteredColumns.forEach((column) => {
    column.title = "Tháng " + thang + " năm " + nam;
  });

  useLayoutEffect(() => {
    const resetColumns = () => {
      setColumns([...allColumns.filter((e) => e.show == true)]);
    };

    resetColumns();
  }, [thang]);
  function getAllDatesInMonth(year, month) {
    const startDate = new Date(year, month - 2, 21); // month is 0-indexed
    const endDate = new Date(year, month - 1, 20);
    const dates = [];
    while (startDate <= endDate) {
      dates.push(new Date(startDate)); // clone the date object
      startDate.setDate(startDate.getDate() + 1);
    }

    return dates;
  }
  const setShowColumnsList = (showColumns) => {
    saveTableOptions(
      "RECEIVED_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  // khi tháng này thay đổi thì component sẽ đc render lại -> nó sẽ kiểm tra điều kiện trong useEffec này
  useEffect(() => {
    // Lấy ngày từ tháng trc tới tháng sau
    const datesInFebruary2023 = getAllDatesInMonth(nam, thang);
    const dateOfMonth = [];
    datesInFebruary2023.map((e) => {
      //Check ngày trong tuần
      const dayOfWeek = e.getDay();
      dateOfMonth.push({
        title: e.getDate(),
        width: 65,
        align: "center",
        className: "white",
        children: [
          {
            title: () => {
              switch (dayOfWeek) {
                case 0:
                  return "CN";
                case 1:
                  return "T2";
                case 2:
                  return "T3";
                case 3:
                  return "T4";
                case 4:
                  return "T5";
                case 5:
                  return "T6";
                case 6:
                  return "T7";
              }
            },
            key: `day${e.getDate()}`,
            show: true,
            dataIndex: `day${e.getDate()}`,
            width: 65,
            align: "center",
            className:
              dayOfWeek === 0 || dayOfWeek === 6 ? "green blue" : "white",
          },
        ],
      });
    });

    if (dateOfMonth) {
      columns.find((item) => item.dataIndex === "nam").children = dateOfMonth;
    }
  }, [thang, nam]);

  columns.map((record) => {
    if (record.dataIndex == "nam") {
      if (record.children) {
        for (let i = 0; i < record.children.length; i++) {
          const dataIndex = record.children[i].children.find(
            (item) => item.dataIndex
          );
          if (dataIndex) {
            if (dataIndex) {
              switch (dataIndex.dataIndex) {
                case "day21":
                case "day22":
                case "day23":
                case "day24":
                case "day25":
                case "day26":
                case "day27":
                case "day28":
                case "day29":
                case "day30":
                case "day31":
                case "day1":
                case "day2":
                case "day3":
                case "day4":
                case "day5":
                case "day6":
                case "day7":
                case "day8":
                case "day9":
                case "day10":
                case "day11":
                case "day12":
                case "day13":
                case "day14":
                case "day15":
                case "day16":
                case "day17":
                case "day18":
                case "day19":
                case "day20":
                  dataIndex.render = (value, record, index) => (
                    (
                      <Select
                        className="Select-ListTimekeeping"
                        style={{
                          width: "100%",
                          backgroundColor:
                            value === "TRUE"
                              ? "red"
                              : value === "x"
                              ? "#f1f1f153"
                              : value === "FALSE"
                              ? "yellow"
                              : value !== "0" &&
                                (dataIndex.className.includes("blue") ||
                                  dataIndex.className.includes("green"))
                              ? "#FFFF66"
                              : "white",
                          borderRadius: "5px",
                        }}
                        options={listCharacters}
                        value={
                          value === "TRUE"
                            ? "0"
                            : value === "FALSE"
                            ? "0"
                            : value
                        }
                        onChange={(e, option: any) => {
                          const fieldName = dataIndex.dataIndex;
                          setData((prevDataTable) => {
                            return prevDataTable.map((prevItem, ind) =>
                              ind === index
                                ? {
                                    ...prevItem,
                                    [fieldName]: option.label,
                                  }
                                : prevItem
                            );
                          });
                        }}
                        disabled={value === "x" || isApproveRecord(record)}
                      ></Select>
                    )
                  );
              }
            }
          }
        }
      }
    }
  });
  const onFinish = (value) => {};
  const spanSymbolClass = showDescriptions ? "show" : "hide";
  const squareStyle = {
    display: "inline-block",
    width: "16px",
    height: "16px",
    borderRadius: "2px",
    marginTop: "8px",
  };
  const textStyle = {
    marginRight: "15px",
    fontFamily: "Segoe UI",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "20px",
    fontSize: "14px",
  };
  const spanSymbol = {
    color: "#00B335",
    fontSize: "14px",
    fontFamily: "Segoe UI",
    fontWeight: "600",
    lineHeight: "20px",
    marginLeft: "4px",
  };
  const frame = {
    marginLeft: "2px",
    marginBottom: "-4px",
  };

  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);

  // const onSave = (e) => {
  //   if (e.key === "Enter") {
  //     handleSubmit();
  //   }
  //   console.log("🚀 ~ file: ListTimekeeping.tsx:1195 ~ onSave ~ e:", e)
  // };

  return (
    <Form form={form}>
      <div className="recruitment-list" tabIndex={0}>
        <div className="recruitment-container">
          <div className="container" onKeyDown={onKeyDownSearch}>
            <ExpandSearchHCNS
              ref={expandRef}
              fields={inputFieldsInit}
              onClickSearch={onClickSearch}
              // Ẩn nút "Tìm kiếm nâng cao"
              isSearchExpend={false}
              isResetField={false}
            />
          </div>
          <div className="container" onKeyDown={onKeyDown}>
            <Space style={{ width: "100%" }} direction="vertical">
              <Row justify={"space-between"} gutter={[16, 8]}>
                <Col span={30}>
                  <Row>
                    <div style={{ marginRight: 12 }}>
                      <Popover
                        trigger="click"
                        placement="topLeft"
                        content={
                          <ColumnPopoverDisplay
                            setShowColumns={setShowColumns}
                            columns={columns}
                            width={"400px"}
                          ></ColumnPopoverDisplay>
                        }
                      >
                        <Button
                          icon={<Icons.bars rev={0} />}
                          className="btn-sub"
                          type="ghost"
                        >
                          Cột hiển thị
                        </Button>
                      </Popover>
                    </div>
                    <div>
                      <span
                        style={{ ...squareStyle, backgroundColor: "#69FFD4" }}
                      ></span>
                      <span style={textStyle}> Cuối tuần</span>
                      {showDescriptions ? (
                        <span
                          className="symbol"
                          onClick={toggleDescriptions}
                          style={spanSymbol}
                        >
                          Ẩn ký hiệu <FrameUp style={frame} />
                        </span>
                      ) : (
                        <span
                          className="symbol"
                          onClick={toggleDescriptions}
                          style={spanSymbol}
                        >
                          Xem ký hiệu <FrameDow style={frame} />
                        </span>
                      )}
                    </div>
                  </Row>
                </Col>
                <Col>
                  <Space
                    style={{
                      width: "100%",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      justifyContent: "start",
                    }}
                  >
                    {/* <Button
                      className="btn-sub"
                      type="ghost"
                      icon={<Icons.add rev={0} />}
                      onClick={handleOnAdd}
                      disabled={isNhanVien() || isQuanLy() || isGiamDoc()}
                    >
                      Phát sinh bảng công
                    </Button> */}
                    {/* <Button
                      type="primary"
                      className="btn-sub"
                      onClick={onClickKiCong}
                    >
                      Cập nhật kỳ công
                    </Button> */}
                    <Button
                      className="custom-btn"
                      type="default"
                      onClick={onClickExport}
                      icon={<ExcelSVG />}
                    >
                      <Typography>Xuất báo cáo</Typography>
                    </Button>
                    {/* <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleUpload}
                      ref={fileInputRef}
                    /> */}
                    {/* <Button
                      icon={<Icons.upload rev={0} />}
                      className="btn-sub"
                      type="ghost"
                      onClick={handleClick}
                      style={{
                        width: "100px",
                      }}
                    >
                      Tải lên
                    </Button> */}
                    <Button
                      className="custom-btn"
                      type="primary"
                      htmlType="submit"
                      onClick={handleSubmit}
                      icon={<SaveWhiteIconSVG />}
                      disabled={isNhanVien() || isQuanLy() || isGiamDoc()}
                    >
                      Lưu lại
                    </Button>
                  </Space>
                </Col>
              </Row>
              <Row justify={"space-between"} gutter={[0, 0]}>
                {showDescriptions && (
                  <div>
                    <Descriptions
                      className="custom-descriptions"
                      column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 3 }}
                    >
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="NP"
                      >
                        Nghỉ phép 1 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="1/2P"
                      >
                        Nghỉ phép 1/2 ngày; đi làm 1/2 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="0.5P"
                      >
                        Nghỉ phép 1/2 ngày; 1/2 ngày không lương
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="NB"
                      >
                        Nghỉ bù 1 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="1/2B"
                      >
                        Nghỉ bù 1/2 ngày; đi làm 1/2 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="0.5B"
                      >
                        Nghỉ bù 1/2 ngày; 1/2 ngày không lương
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="B/P"
                      >
                        Nghỉ phép 1/2 ngày; nghỉ bù 1/2 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="NL"
                      >
                        Nghỉ lễ
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="ÔC"
                      >
                        Nghỉ ốm 1 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="1/2ÔC"
                      >
                        Nghỉ ốm công ty 1/2 ngày; đi làm 1/2 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="KL"
                      >
                        Nghỉ không lương
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="1"
                      >
                        Đi làm 1 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="0.5"
                      >
                        Đi làm 1/2 ngày; nghỉ không lương 1/2 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="TS"
                      >
                        Nghỉ thai sản
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="Ô"
                      >
                        Nghỉ ốm hưởng BHXH
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="CĐ"
                      >
                        Nghỉ chế độ
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="0.5ÔC"
                      >
                        Nghỉ ốm công ty 1/2 ngày; nghỉ không lương 1/2 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="MT"
                      >
                        Nghỉ Mental health 1 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="0.5NL"
                      >
                        Nghỉ lễ 1/2 ngày; nghỉ không lương 1/2 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="0.5MT"
                      >
                        Nghỉ Mental health 1/2 ngày; nghỉ không lương 1/2 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="CÔ"
                      >
                        Nghỉ con ốm hưởng BHXH
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="1/2CÔ"
                      >
                        Nghỉ con ốm hưởng BHXH 1/2 ngày; đi làm 1/2 ngày
                      </Descriptions.Item>
                      <Descriptions.Item
                        className="custom-descriptions-item"
                        label="0.5CÔ"
                      >
                        Nghỉ con ốm hưởng BHXH 1/2 ngày; nghỉ không lương 1/2
                        ngày
                      </Descriptions.Item>
                    </Descriptions>
                  </div>
                )}
              </Row>
              {data && (
                <CustomResizableTable
                  setShowColumns={setShowColumnsList}
                  pagination={{
                    position: ["bottomRight"],
                    showSizeChanger: true,
                    total: employees.ChamCongTotal,
                    onChange: onChangePagination,
                    current: currentPage,
                  }}
                  rowKey={(record) => record.id}
                  columns={columns}
                  dataSource={data}
                  bordered={true}
                  loading={loading}
                  scroll={{ x: scrollX }}
                  size="middle"
                />
              )}
            </Space>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default ListTimekeeping;
